import type {IResourceManager} from "./IResourceManager";

export interface ResourceManagerTaskConstructorArguments {
    context?:unknown;
    callback?:(data)=>void;
    prerequisites?:ResourceManagerTaskPrerequisite[];
    taskName? : string;
    invalidatedWhen? : string;
}


export class ResourceManagerTask {
    prerequisites :ResourceManagerTaskPrerequisite[];
    taskName : string;
    private callback;
    private context;
    invalidatedWhen : string[];
    private registerAsResourceAfterExecution = true;
    private static resourceManager: IResourceManager;

    public static setResourceManager(resourceManager:IResourceManager) {
        ResourceManagerTask.resourceManager = resourceManager;
    }

    constructor(args : ResourceManagerTaskConstructorArguments) {
        this.prerequisites = args.prerequisites || [];
        this.taskName = args.taskName || "not specified";
        this.callback = args.callback || function(){console.log("empty callback!")};
        this.context = args.context || null;
        if (args.invalidatedWhen) {
            this.invalidatedWhen = [args.invalidatedWhen];
        } else {
            this.invalidatedWhen = [];
        }
    }

    execute (dataObject) {
        this.callback.call(this.context, dataObject);
        if(!this.registerAsResourceAfterExecution) {
            return;
        }
        ResourceManagerTask.resourceManager.registerResource({
            resourceName: this.taskName,
            startingStati: ["done"],
        }).addMultipleInvalidationTriggers(this.invalidatedWhen);
    }

    processMultipleRequirements (reqArray : ResourceManagerTaskPrerequisite[]) :ResourceManagerTask {
        for (let i = 0, lenI = reqArray.length; i < lenI; i++) {
            this.prerequisites.push(reqArray[i]);
        }
        return this;
    }

    invalidAfter (invalidAfterEvent : string):ResourceManagerTask {
        this.invalidatedWhen.push(invalidAfterEvent);
        return this;
    }

    addMultipleInvalidationTriggers(eventNames : string[]) :ResourceManagerTask{
        this.invalidatedWhen = this.invalidatedWhen.concat(eventNames);
        return this;
    }

    start = ()=>ResourceManagerTask.resourceManager.addOrExecuteTask(this);


    when (resourceName :string, state : string) :ResourceManagerTask{
        this.prerequisites.push(new ResourceManagerTaskPrerequisite(resourceName, [state]));
        return this;
    }

    whenLoaded(resourceName:string):ResourceManagerTask {
        this.prerequisites.push(new ResourceManagerTaskPrerequisite(resourceName, ["loaded"]));
        return this;
    }

    discardAfterExecution = ()=>{
        this.registerAsResourceAfterExecution = false;
        return this;
    };

    whenMultipleRequirementsMet(resourceObject : ResourceManagerTaskPrerequisite[]) :ResourceManagerTask{
        this.processMultipleRequirements(resourceObject);
        return this;
    }

    andWhen = this.when;

    thenDo (callback:(data)=>void):void {
        this.thenDoWithoutStarting(callback);
        this.start();
    }

    thenDoWithoutStarting (callback:(data)=>void):ResourceManagerTask {
        this.callback = callback;
        return this;
    }

    withContext (context) :ResourceManagerTask{
        this.context = context;
        return this;
    }
}


/**
 * Datenklasse für Vorraussetzungen
 * Beispiel für eine prerequisite : Der Task "loadLanguageTexts" hat die Prerequisite resourceName:"datamodel", stati: "sprache toBeNotEmpty"
 */
export class ResourceManagerTaskPrerequisite {
    resourceName : string;
    prerequisites : string[];

    constructor(resourceName : string, stati : string[]) {
        this.resourceName = resourceName;
        this.prerequisites = stati;
    }
}
